import { AbstractControl, FormControl } from "@angular/forms";
import moment from "moment";

export class DateUtils{

    public static getNow():string{
        
        return moment().format("YYYY-MM-DD HH:mm:ss.SSS");

    }

    public static getNowFormatted(pattern):string{
        
      return moment().format(pattern);

  }

    public static isValidFormat(control: AbstractControl): object | null {
        /*if (moment.isMoment(control.value)) {
          const input = control.value.creationData().input;
          if (typeof input === 'string' && (RegExp.DATE).test(input)
              || typeof input === 'object' && input.hasOwnProperty('year') && 
              input.hasOwnProperty('month') && input.hasOwnProperty('date')) {
            return null;
          }
        }
    
        if (!control.value && control.errors && control.errors.matDatepickerParse) {
          const datePickerText = control.errors.matDatepickerParse.text;
          if (!datePickerText) {
            return null;
          }
        }*/
    
        return { pattern: true };
      }

  
  public static addDays(date: Date, days: number): Date {
        date.setDate(date.getDate() + days);
        return date;
    }
   
}